import { render } from "./SendSellCoinSuccess.vue?vue&type=template&id=32832716"
import script from "./SendSellCoinSuccess.vue?vue&type=script&lang=js"
export * from "./SendSellCoinSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__